import React from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { localize } from 'react-localize-redux';
import 'react-dates/lib/css/_datepicker.css';
import { translate } from 'react-i18next';

import '../../assets/css/react-dates.override.css';
import i18n from '../../translations/i18n';

class DateRangeFilterField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focusedInput: null,
      startDate: null,
      endDate: null,
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate });

    if (startDate && endDate) {
      startDate = moment(startDate).startOf('day');
      endDate = moment(endDate).startOf('day');
      this.props.onFilterChange({ startDate, endDate });
    }

    if (!startDate && !endDate) {
      this.props.onFilterChange();
    }
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;

    return (
      <DateRangePicker
        focusedInput={focusedInput}
        startDate={startDate}
        withPortal
        initialVisibleMonth={() => moment().subtract(1, 'month')}
        displayFormat={'DD.MM.YYYY'}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel
        showClearDates
        endDate={endDate}
        onDatesChange={this.onDatesChange}
        onFocusChange={this.onFocusChange}
        startDatePlaceholderText={this.props.t('start_date')}
        endDatePlaceholderText={this.props.t('end_date')}
      />
    );
  }
}

const extended = translate(['translations'], { i18n })(DateRangeFilterField);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/filters/DateRangeFilterField.js